// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
function getSetVh() { 
    const roundedVh = Math.round(window.visualViewport.height * 0.01); 
    document.body.style.setProperty('--vh', `${roundedVh}px`) 
}

// Browser check
// Browser and device detection
function getNavigator() {
    const html = document.documentElement;
    
    // Feature-based detection
    const isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const isSafari = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
    const isChrome = /Chrome/.test(navigator.userAgent) && !/Edge|Edg/.test(navigator.userAgent);
    const isFirefox = /Firefox/.test(navigator.userAgent);
    const isEdge = /Edge|Edg/.test(navigator.userAgent);
    
    // Touch support detection
    const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    
    // Apply classes
    if (isiOS) html.classList.add('ios');
    if (hasTouch) html.classList.add('touch');
    
    // Browser classes and events
    const browsers = [
        { test: isSafari, name: 'safari' },
        { test: isChrome, name: 'chrome' },
        { test: isFirefox, name: 'firefox' },
        { test: isEdge, name: 'edge' }
    ];
    
    browsers.forEach(({ test, name }) => {
        if (test) {
            html.classList.add(name);
            window.dispatchEvent(new CustomEvent('user-agent', { detail: { browser: name } }));
        }
    });
}

// Get and set element size
function getElementSize({ elementSelector, targetSelector = 'this', axis = 'both', cssVar }) {
    // Helper function to resolve the element(s)
    const resolveElements = selector => {
        if (typeof selector === 'string') {
            return document.querySelectorAll(selector);
        } else if (selector instanceof NodeList || Array.isArray(selector)) {
            return selector;
        } else {
            return [selector];
        }
    };

    // Resolve the elements and target element
    const elements = resolveElements(elementSelector);
    const targetElement = targetSelector === 'this' ? elements[0] : resolveElements(targetSelector)[0];

    // Exit early if elements are not found or cssVar is not provided
    if (!elements.length || !targetElement || !cssVar) return;

    const calculateAndSetSize = () => {
        let totalWidth = 0;
        let totalHeight = 0;

        // Calculate the total width and height including margins
        elements.forEach(element => {
            const style = window.getComputedStyle(element);
            totalWidth += element.offsetWidth + parseFloat(style.marginLeft || 0) + parseFloat(style.marginRight || 0);
            totalHeight += element.offsetHeight + parseFloat(style.marginTop || 0) + parseFloat(style.marginBottom || 0);
        });

        // Helper function to set CSS variables
        const setCssVariable = (prop, value) => targetElement.style.setProperty(`--${cssVar}${prop}`, `${value}px`);

        // Set the CSS variables based on the axis parameter
        if (axis.includes('width') || axis === 'both') setCssVariable('Width', totalWidth);
        if (axis.includes('height') || axis === 'both') setCssVariable('Height', totalHeight);
    };

    // Initial size calculation
    calculateAndSetSize();

    // Use ResizeObserver to observe changes in the elements' sizes
    const observer = new ResizeObserver(() => {
        calculateAndSetSize();
    });

    // Observe each element
    elements.forEach(element => {
        observer.observe(element);
    });
}


/***
// === [ CORETEX FYI ] ===
// Usage example

getElementSize({
    elementSelector: '.source', // Selects the element to measure
    targetSelector: '.target', // Specifies where to apply the CSS variables. Replace '.target' with 'this' to apply on the same element as '.source'
    axis: 'both', // Indicates that both width and height should be measured and set
    cssVar: 'css-var-target-size' // The base name for the CSS variables to be applied
});

// Explanation of parameters:
- elementSelector: The selector for the element from which to get the size. Here, '.source' is used to find an element with the class 'source'.
- targetSelector: The selector for the target element where the CSS variables will be set. Use 'this' to refer to the same element as 'elementSelector'. Here, '.target' is used to specify a different element with the class 'target'.
- axis: Specifies which dimensions to operate on. It can be 'width', 'height', or 'both'. In this case, 'both' is used to indicate that both dimensions should be processed.
- cssVar: The base name for the CSS variables that will be set on the target element. The function will create '--css-var-target-size-width' and '--css-var-target-size-height' variables if 'both' is selected for the axis.
*/

class MediaQueryUtility {
  constructor() {
    this.breakpoints = {
      mobile: 777,
      tablet: 1024
    };

    this.executeBasedOnViewport = this.executeBasedOnViewport.bind(this);
    this.updateHTMLClass = this.updateHTMLClass.bind(this);

    // Call updateHTMLClass on initialization and resize
    this.updateHTMLClass();
    window.addEventListener('resize', this.updateHTMLClass);
  }

  getViewport() {
    const width = window.innerWidth;
    if (width <= this.breakpoints.mobile) return 'mobile';
    if (width <= this.breakpoints.tablet) return 'tablet';
    return 'desktop';
  }

  executeBasedOnViewport(callbacks = {}) {
    const viewport = this.getViewport();
    const callback = callbacks[viewport];

    // Silently exit if no callback is defined for the viewport
    if (typeof callback !== 'function') return;
    try { callback(); } catch (error) { return; }
  }

  updateHTMLClass() {
    const html = document.documentElement;
    const currentViewport = this.getViewport();
    
    // Remove all viewport classes
    html.classList.remove('mq-mobile', 'mq-tablet', 'mq-desktop');

    // Add the current viewport class
    html.classList.add(`mq-${currentViewport}`);
  }
} const mediaQuery = new MediaQueryUtility(); // Initialize the media query utility

/***
    // === [ CORETEX FYI ] ===
    // Usage example

    // executeBasedOnViewport
    mediaQuery.executeBasedOnViewport({
        mobile: () => {
            console.log('Executing mobile-specific code');
            document.querySelector('drawer-footer').setAttribute('aria-hidden', 'false');
        },
        tablet: () => {
            console.log('Executing tablet-specific code');

        },
        desktop: () => {
            console.log('Executing desktop-specific code'); 
            
        }
    });

*/

function globalTasks() {
    getSetVh(); // Update viewport height
    getElementSize({ elementSelector: '[class*="group-header-group"]', targetSelector: '#pageBody', axis: 'height', cssVar: 'headerGroup' }); // Get header group height
    getElementSize({ elementSelector: '#mainHeader', targetSelector: '#pageBody', axis: 'height', cssVar: 'header' }); // Get header height
    hydrateHomepageSectionAnalytics();
    trackAttributedPageView();
    trackRecentlyViewedProduct();
    initProductCollectButtons();
    syncCartDrawerContent();
    // executeBasedOnViewport
    mediaQuery.executeBasedOnViewport({
        mobile: () => {
            // console.log('media query: mobile');
            document.querySelector('drawer-footer').setAttribute('aria-hidden', 'false');
        },
        tablet: () => {
            // console.log('media query: tablet')
        },
        desktop: () => {
            // console.log('media query: desktop')
            document.querySelector('drawer-footer').setAttribute('aria-hidden', 'true');
        }
    });
}

// Is in viewport
function inViewport(selector, callback, options = {}, autoUnobserve = false) {
    // Select the elements based on the provided selector. It could be one element or multiple.
    // target single or multiple elements using any valid CSS selector. 
    // This could be a class, ID, tag, or a combination that represents one or more elements.
    const elements = document.querySelectorAll(selector);

    if (!elements.length) {
        console.error(`(inViewport) - No elements found for selector: ${selector}`);
        return;
    }

    // Define the observer with the callback and options.
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            // Execute the callback for each entry.
            callback(entry);

            // Check if autoUnobserve is true and the entry is intersecting, then unobserve.
            if (autoUnobserve && entry.isIntersecting) observer.unobserve(entry.target);
        });
    }, options);

    elements.forEach(element => observer.observe(element));

    // Return the observer instance to allow external control, e.g., manual disconnect.
    return observer;
}


/***
// === [ CORETEX FYI ] ===
// Example usage

// Observing multiple items
const observer = inViewport('.item-to-observe, [data-to-observe]', entry => {
    if (entry.isIntersecting) {
        console.log('Element is in the viewport!', entry.target);
        // You can do something specific with each element here, like adding a class or triggering animations.
    } else {
        console.log('Element has left the viewport.', entry.target);
    }
}, {}, false); // The last parameter 'false' is for autoUnobserve, modify based on your requirement.

*/

/*** Cart */
const MYSTO_SECTION_ANALYTICS_STORAGE_KEY = 'mysto-section-origin';
const MYSTO_SECTION_ANALYTICS_MAX_AGE = 30 * 60 * 1000;
const MYSTO_SECTION_VIEW_THRESHOLD = 0.35;
const MYSTO_SECTION_METADATA_OVERRIDES = {
    ls_hero_UCPVk9: {
        section_name: 'Hero banner',
        section_type: 'ls-hero',
        headline: 'Beyond Layers / Beyond Seasons',
        primary_cta_label: 'Shop now',
        primary_target_type: 'collection',
        primary_target_handle: 'fine-cashmere',
        creative_theme: 'wardrobe system / seasonless layering',
        funnel_stage: 'awareness',
        product_family: 'fine cashmere',
        style_keywords: 'beyond layers; beyond seasons; softness; ease',
    },
    '177804685953e42c56': {
        section_name: 'Core-Form-Drape',
        section_type: '_blocks',
        headline: 'The Essence / The Layer / The Form',
        primary_cta_label: 'Explore collections',
        primary_target_type: 'collection',
        primary_target_handle: 'the-essence',
        creative_theme: 'wardrobe taxonomy / self-selection',
        funnel_stage: 'consideration',
        product_family: 'the essence; the layer; the form',
        style_keywords: 'closest; lightest; ease; soften; warm',
    },
    ls_multicolumn_QCBMCD: {
        section_name: 'Hero multicolumn',
        section_type: 'ls-multicolumn',
        headline: 'A rhythm of ease / Matching Set',
        primary_cta_label: 'Explore product',
        primary_target_type: 'product',
        primary_target_handle: 'linea-air-ruffle-top',
        creative_theme: 'editorial product highlight',
        funnel_stage: 'consideration',
        product_family: 'linea',
        style_keywords: 'matching set; rhythm; move; refined',
    },
    '1777405396b12933ee': {
        section_name: 'Outfit grid + social proof',
        section_type: '_blocks',
        headline: 'The Form / The Linea / The Mist',
        primary_cta_label: 'Explore looks',
        primary_target_type: 'product',
        primary_target_handle: 'noir-dual-zip-jacket',
        creative_theme: 'outfit exploration / social proof',
        funnel_stage: 'consideration-retargeting',
        product_family: 'mixed',
        style_keywords: 'lived in; personal style; color story; creator',
    },
};
const mystoTrackedSectionViews = new Set();
const mystoTrackedAttributedPageViews = new Set();
const mystoSectionMetadata = new WeakMap();
const MYSTO_COLLECT_STORAGE_KEY = 'mysto-collected-products';
const MYSTO_RECENTLY_VIEWED_STORAGE_KEY = 'mysto-recently-viewed-products';
const MYSTO_CART_NOTICE_DURATION = 3000;
const MYSTO_RECENTLY_VIEWED_LIMIT = 10;
let mystoCartNoticeTimeoutId;
let mystoCartNoticeHideTimeoutId;
let latestCartForm = null;
let mystoSectionViewObserver;
let pendingAddToCartAnalytics = null;

function readSessionJson(key, fallback = null) {
    try {
        const value = sessionStorage.getItem(key);
        return value ? JSON.parse(value) : fallback;
    } catch (error) {
        return fallback;
    }
}

function writeSessionJson(key, value) {
    try {
        sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
        return;
    }
}

function normalizeText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
}

function normalizePathname(value) {
    try {
        const url = new URL(value, window.location.origin);
        let pathname = url.pathname || '/';
        if (pathname.length > 1) pathname = pathname.replace(/\/+$/, '');
        return pathname || '/';
    } catch (error) {
        return '';
    }
}

function getPageType() {
    return document.body?.getAttribute('coretex-page') || '';
}

function getCurrentUrl() {
    return new URL(window.location.href);
}

function getCurrentUtmContext(url = getCurrentUrl()) {
    return {
        utm_source: url.searchParams.get('utm_source') || '',
        utm_medium: url.searchParams.get('utm_medium') || '',
        utm_campaign: url.searchParams.get('utm_campaign') || '',
    };
}

function getSectionIdFromValue(value) {
    const cleaned = String(value || '').replace(/^shopify-section-/, '');
    return cleaned.includes('__') ? cleaned.split('__').pop() : cleaned;
}

function formatSectionNameFromId(sectionId) {
    return sectionId
        .replace(/^_+/, '')
        .split(/[_-]+/)
        .filter(Boolean)
        .map(token => token.charAt(0).toUpperCase() + token.slice(1))
        .join(' ');
}

function inferSectionTypeFromId(sectionId) {
    if (/^ls_hero_text_/.test(sectionId)) return 'ls-hero-text';
    if (/^ls_hero_/.test(sectionId)) return 'ls-hero';
    if (/^ls_multicolumn_/.test(sectionId)) return 'ls-multicolumn';
    if (/^s_space_/.test(sectionId)) return 's-space';
    if (/^\d/.test(sectionId) || /^blocks_/.test(sectionId)) return '_blocks';
    return sectionId.split('_').slice(0, 2).join('-') || 'section';
}

function getDestinationInfo(target) {
    const href = target?.getAttribute?.('href') || target?.href || '';
    if (!href) {
        return {
            destination_type: '',
            destination_handle: '',
            destination_path: '',
            destination_url: '',
            is_internal: false,
        };
    }

    try {
        const url = new URL(href, window.location.origin);
        const pathname = normalizePathname(url.href);
        const parts = pathname.split('/').filter(Boolean);
        const isInternal = url.origin === window.location.origin;
        let destinationType = '';
        let destinationHandle = '';

        if (parts[0] === 'products' && parts[1]) {
            destinationType = 'product';
            destinationHandle = decodeURIComponent(parts[1]);
        } else if (parts[0] === 'collections' && parts[1]) {
            destinationType = 'collection';
            destinationHandle = decodeURIComponent(parts[1]);
        } else if (isInternal) {
            destinationType = 'page';
            destinationHandle = parts.join('/') || 'home';
        }

        return {
            destination_type: destinationType,
            destination_handle: destinationHandle,
            destination_path: pathname,
            destination_url: url.toString(),
            is_internal: isInternal,
        };
    } catch (error) {
        return {
            destination_type: '',
            destination_handle: '',
            destination_path: '',
            destination_url: '',
            is_internal: false,
        };
    }
}

function getPrimarySectionLink(sectionElement) {
    const sectionLinks = Array.from(sectionElement.querySelectorAll('a[href]'));
    let firstInternalLink = null;

    for (const link of sectionLinks) {
        const destination = getDestinationInfo(link);
        if (!destination.is_internal) continue;
        if (!firstInternalLink) firstInternalLink = link;
        if (destination.destination_type === 'product' || destination.destination_type === 'collection') {
            return link;
        }
    }

    return firstInternalLink || sectionLinks[0] || null;
}

function getSectionHeadline(sectionElement) {
    const selectors = [
        'h1',
        'h2',
        'h3',
        'h4',
        '.title .label',
        '.title',
        '.heading',
        '.headline',
        '.content h1',
        '.content h2',
        '.content h3',
    ];

    for (const selector of selectors) {
        const element = sectionElement.querySelector(selector);
        const text = normalizeText(element?.textContent);
        if (text) return text.slice(0, 180);
    }

    const fallbackText = normalizeText(sectionElement.querySelector('.content.rte, .content, p')?.textContent);
    return fallbackText ? fallbackText.slice(0, 180) : '';
}

function getSectionSupportingCopy(sectionElement, headline = '') {
    const selectors = ['p', '.content.rte', '.content', '.label'];

    for (const selector of selectors) {
        const elements = sectionElement.querySelectorAll(selector);
        for (const element of elements) {
            const text = normalizeText(element.textContent);
            if (!text || text === headline || text.length < 24) continue;
            return text.slice(0, 260);
        }
    }

    return '';
}

function buildHomepageSectionMeta(wrapper, sectionOrder = 0) {
    const sectionRoot = wrapper.querySelector('[data-section-id]') || wrapper.firstElementChild || wrapper;
    const rawSectionId = getSectionIdFromValue(sectionRoot.getAttribute('data-section-id') || wrapper.id);
    const override = MYSTO_SECTION_METADATA_OVERRIDES[rawSectionId] || {};
    const primaryLink = getPrimarySectionLink(wrapper);
    const destination = getDestinationInfo(primaryLink);
    const headline = override.headline || getSectionHeadline(wrapper);
    const supportingCopy = override.supporting_copy || getSectionSupportingCopy(wrapper, headline);
    const primaryLabel = override.primary_cta_label || normalizeText(
        primaryLink?.getAttribute('aria-label')
        || primaryLink?.getAttribute('title')
        || primaryLink?.textContent,
    );

    return {
        section_id: rawSectionId,
        section_order: sectionOrder,
        section_name: override.section_name || headline || formatSectionNameFromId(rawSectionId),
        section_type: override.section_type || inferSectionTypeFromId(rawSectionId),
        page_type: 'index',
        status: 'live',
        headline,
        supporting_copy: supportingCopy,
        primary_cta_label: primaryLabel,
        primary_target_type: override.primary_target_type || destination.destination_type,
        primary_target_handle: override.primary_target_handle || destination.destination_handle,
        creative_theme: override.creative_theme || '',
        funnel_stage: override.funnel_stage || '',
        product_family: override.product_family || '',
        style_keywords: override.style_keywords || '',
    };
}

function shouldTrackHomepageSection(wrapper, meta) {
    if (!meta.section_id || meta.section_type === 's-space') return false;
    if (wrapper.hidden) return false;

    const wrapperStyles = window.getComputedStyle(wrapper);
    if (wrapperStyles.display === 'none' || wrapperStyles.visibility === 'hidden') return false;

    return Boolean(meta.headline || meta.primary_target_handle || wrapper.querySelector('a[href]'));
}

function emitMystoAnalyticsEvent(eventName, payload = {}) {
    const eventPayload = {
        event: eventName,
        event_name: eventName,
        timestamp: new Date().toISOString(),
        page_type: getPageType(),
        page_path: normalizePathname(window.location.href),
        ...getCurrentUtmContext(),
        ...payload,
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventPayload);

    window.mystoAnalyticsEvents = window.mystoAnalyticsEvents || [];
    window.mystoAnalyticsEvents.push(eventPayload);

    document.dispatchEvent(new CustomEvent('mysto:analytics', {
        detail: eventPayload,
    }));

    return eventPayload;
}

function ensureSectionViewObserver() {
    if (mystoSectionViewObserver || !('IntersectionObserver' in window)) return;

    mystoSectionViewObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (!entry.isIntersecting || entry.intersectionRatio < MYSTO_SECTION_VIEW_THRESHOLD) return;

            const meta = mystoSectionMetadata.get(entry.target);
            if (!meta?.section_id) {
                observer.unobserve(entry.target);
                return;
            }

            const viewKey = `${meta.page_type}:${meta.section_id}`;
            if (mystoTrackedSectionViews.has(viewKey)) {
                observer.unobserve(entry.target);
                return;
            }

            mystoTrackedSectionViews.add(viewKey);
            emitMystoAnalyticsEvent('section_view', meta);
            observer.unobserve(entry.target);
        });
    }, {
        threshold: [MYSTO_SECTION_VIEW_THRESHOLD],
        rootMargin: '0px 0px -10% 0px',
    });
}

function hydrateHomepageSectionAnalytics() {
    if (getPageType() !== 'index') return;

    const mainContent = document.querySelector('#mainContent');
    if (!mainContent) return;

    ensureSectionViewObserver();

    let trackedOrder = 0;

    Array.from(mainContent.children).forEach(wrapper => {
        if (!wrapper.classList?.contains('shopify-section')) return;

        const meta = buildHomepageSectionMeta(wrapper, trackedOrder + 1);
        if (!shouldTrackHomepageSection(wrapper, meta)) return;

        trackedOrder += 1;
        meta.section_order = trackedOrder;
        mystoSectionMetadata.set(wrapper, meta);

        wrapper.setAttribute('data-mysto-section-id', meta.section_id);
        wrapper.setAttribute('data-mysto-section-order', String(meta.section_order));
        wrapper.setAttribute('data-mysto-section-type', meta.section_type || '');
        wrapper.setAttribute('data-mysto-section-name', meta.section_name || '');

        if (mystoSectionViewObserver && wrapper.dataset.mystoSectionObserved !== 'true') {
            wrapper.dataset.mystoSectionObserved = 'true';
            mystoSectionViewObserver.observe(wrapper);
        }
    });
}

function rememberSectionOrigin(meta, destination) {
    const origin = {
        ...meta,
        ...getCurrentUtmContext(),
        attribution_status: 'home_section',
        origin_page_type: 'index',
        origin_page_path: normalizePathname(window.location.href),
        origin_timestamp: new Date().toISOString(),
        destination_type: destination.destination_type,
        destination_handle: destination.destination_handle,
        destination_path: destination.destination_path,
        destination_url: destination.destination_url,
        stored_at: Date.now(),
    };

    writeSessionJson(MYSTO_SECTION_ANALYTICS_STORAGE_KEY, origin);
    window.mystoSectionOriginContext = origin;

    if (origin.section_id) {
        document.body?.setAttribute('data-mysto-section-origin', origin.section_id);
    }

    return origin;
}

function getStoredSectionOrigin() {
    const storedOrigin = readSessionJson(MYSTO_SECTION_ANALYTICS_STORAGE_KEY);
    const storedAt = Number(storedOrigin?.stored_at || 0);

    if (!storedOrigin || !storedAt) return null;
    if (Date.now() - storedAt <= MYSTO_SECTION_ANALYTICS_MAX_AGE) return storedOrigin;

    try {
        sessionStorage.removeItem(MYSTO_SECTION_ANALYTICS_STORAGE_KEY);
    } catch (error) {
        return null;
    }

    return null;
}

function syncActiveSectionOrigin() {
    const activeOrigin = getStoredSectionOrigin();
    window.mystoSectionOriginContext = activeOrigin;

    if (activeOrigin?.section_id) {
        document.body?.setAttribute('data-mysto-section-origin', activeOrigin.section_id);
    } else {
        document.body?.removeAttribute('data-mysto-section-origin');
    }

    return activeOrigin;
}

function trackAttributedPageView() {
    const activeOrigin = syncActiveSectionOrigin();
    const pageType = getPageType();

    if (!activeOrigin || !['product', 'collection'].includes(pageType)) return;

    const pagePath = normalizePathname(window.location.href);
    const pageKey = `${pageType}:${pagePath}:${activeOrigin.section_id}`;
    if (mystoTrackedAttributedPageViews.has(pageKey)) return;

    const currentDestination = getDestinationInfo({ href: pagePath });
    mystoTrackedAttributedPageViews.add(pageKey);

    emitMystoAnalyticsEvent(
        pageType === 'product' ? 'section_product_view' : 'section_collection_view',
        {
            ...activeOrigin,
            page_type: pageType,
            page_path: pagePath,
            origin_destination_type: activeOrigin.destination_type,
            origin_destination_handle: activeOrigin.destination_handle,
            origin_destination_path: activeOrigin.destination_path,
            destination_type: currentDestination.destination_type || pageType,
            destination_handle: currentDestination.destination_handle,
            destination_path: pagePath,
        },
    );
}

function isLikelyCta(element) {
    if (!element) return false;
    if (element.matches('button, summary.button, [role="button"], .button, [class*="button"]')) return true;
    return Boolean(element.closest('.buttons, .cta, .viewCart'));
}

function trackHomepageSectionClick(event) {
    if (getPageType() !== 'index') return;

    const interactiveElement = event.target.closest('a[href], button, [role="button"], summary.button');
    if (!interactiveElement) return;

    const wrapper = interactiveElement.closest('.shopify-section');
    if (!wrapper || wrapper.parentElement?.id !== 'mainContent') return;

    const meta = mystoSectionMetadata.get(wrapper) || buildHomepageSectionMeta(
        wrapper,
        Number(wrapper.getAttribute('data-mysto-section-order') || 0),
    );
    if (!shouldTrackHomepageSection(wrapper, meta)) return;

    const destination = getDestinationInfo(interactiveElement);
    const clickLabel = normalizeText(
        interactiveElement.getAttribute('aria-label')
        || interactiveElement.getAttribute('title')
        || interactiveElement.textContent
        || destination.destination_handle,
    );

    const eventName = isLikelyCta(interactiveElement)
        ? 'section_cta_click'
        : destination.destination_type === 'product'
            ? 'section_product_click'
            : destination.destination_type === 'collection'
                ? 'section_collection_click'
                : 'section_click';

    emitMystoAnalyticsEvent(eventName, {
        ...meta,
        click_label: clickLabel,
        click_tag: interactiveElement.tagName.toLowerCase(),
        click_role: interactiveElement.getAttribute('role') || '',
        is_primary_cta: Boolean(
            clickLabel
            && meta.primary_cta_label
            && clickLabel.toLowerCase() === meta.primary_cta_label.toLowerCase(),
        ),
        destination_type: destination.destination_type,
        destination_handle: destination.destination_handle,
        destination_path: destination.destination_path,
        destination_url: destination.destination_url,
        attribution_status: 'home_section',
    });

    if (destination.is_internal && destination.destination_path) {
        rememberSectionOrigin(meta, destination);
    }
}

function getProductHandleFromPath(pathname = normalizePathname(window.location.href)) {
    const parts = pathname.split('/').filter(Boolean);
    return parts[0] === 'products' && parts[1] ? decodeURIComponent(parts[1]) : '';
}

function buildAddToCartAnalyticsPayload(formElement, requestState) {
    const activeOrigin = syncActiveSectionOrigin();
    const quantity = Number(
        formElement?.querySelector('input[name="quantity"]')?.value
        || requestState?.requestBody?.quantity
        || 1,
    );

    return {
        ...activeOrigin,
        attribution_status: activeOrigin ? 'home_section' : 'unattributed',
        event_source: 'product_form',
        page_type: getPageType(),
        page_path: normalizePathname(window.location.href),
        product_handle: getProductHandleFromPath(),
        product_id: String(formElement?.querySelector('input[name="product-id"]')?.value || ''),
        variant_id: String(
            formElement?.querySelector('input[name="id"]')?.value
            || requestState?.requestBody?.id
            || '',
        ),
        quantity: Number.isFinite(quantity) && quantity > 0 ? quantity : 1,
    };
}

function isProductPage() {
    return document.body?.getAttribute('coretex-page') === 'product';
}

function getCollectedProducts() {
    try {
        const savedProducts = JSON.parse(localStorage.getItem(MYSTO_COLLECT_STORAGE_KEY) || '[]');
        return Array.isArray(savedProducts) ? savedProducts.map(String) : [];
    } catch (error) {
        return [];
    }
}

function setCollectedProducts(productIds) {
    try {
        localStorage.setItem(MYSTO_COLLECT_STORAGE_KEY, JSON.stringify(productIds));
    } catch (error) {
        return;
    }
}

function getCollectProductId(formElement) {
    return formElement.querySelector('input[name="product-id"]')?.value
        || formElement.querySelector('input[name="id"]')?.value
        || window.location.pathname;
}

function getRecentlyViewedProducts() {
    try {
        const savedProducts = JSON.parse(localStorage.getItem(MYSTO_RECENTLY_VIEWED_STORAGE_KEY) || '[]');
        if (!Array.isArray(savedProducts)) return [];

        return savedProducts
            .filter(product => product && typeof product === 'object')
            .map(product => ({
                url: String(product.url || '').trim(),
                title: String(product.title || '').trim(),
                image: String(product.image || '').trim(),
                price: String(product.price || '').trim(),
            }))
            .filter(product => product.url && product.title && product.image);
    } catch (error) {
        return [];
    }
}

function setRecentlyViewedProducts(products) {
    try {
        localStorage.setItem(
            MYSTO_RECENTLY_VIEWED_STORAGE_KEY,
            JSON.stringify(products.slice(0, MYSTO_RECENTLY_VIEWED_LIMIT)),
        );
    } catch (error) {
        return;
    }
}

function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, character => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
    }[character] || character));
}

function formatRecentlyViewedPrice(rawAmount, rawCurrency) {
    const amount = Number(rawAmount);
    if (!Number.isFinite(amount)) return '';

    const currency = String(rawCurrency || '').trim().toUpperCase() || 'CAD';

    try {
        return new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency,
        }).format(amount);
    } catch (error) {
        return `${currency} ${amount.toFixed(2)}`;
    }
}

function getCurrentProductForRecentlyViewed() {
    if (!isProductPage()) return null;

    const canonicalHref = document.querySelector('link[rel="canonical"]')?.href || window.location.href;
    const productUrl = new URL(canonicalHref, window.location.origin);
    productUrl.hash = '';
    productUrl.search = '';

    const title = document.querySelector('meta[property="og:title"]')?.content?.trim()
        || document.querySelector('h1')?.textContent?.trim()
        || '';
    const image = document.querySelector('meta[property="og:image"]')?.content?.trim()
        || document.querySelector('media-loader img, picture img, img.product__image')?.currentSrc
        || document.querySelector('media-loader img, picture img, img.product__image')?.src
        || '';
    const price = formatRecentlyViewedPrice(
        document.querySelector('meta[property="product:price:amount"]')?.content,
        document.querySelector('meta[property="product:price:currency"]')?.content,
    );

    if (!title || !image) return null;

    return {
        url: productUrl.pathname,
        title,
        image,
        price,
    };
}

function trackRecentlyViewedProduct() {
    const currentProduct = getCurrentProductForRecentlyViewed();
    if (!currentProduct) return;

    const nextProducts = getRecentlyViewedProducts().filter(product => product.url !== currentProduct.url);
    nextProducts.unshift(currentProduct);
    setRecentlyViewedProducts(nextProducts);
}

function getRecentlyViewedCardMarkup(product) {
    const priceMarkup = product.price
        ? `<span class="mysto-cart-recently-viewed__price">${escapeHtml(product.price)}</span>`
        : '';

    return `
        <article class="mysto-cart-recently-viewed__item">
            <a class="mysto-cart-recently-viewed__card" href="${escapeHtml(product.url)}">
                <span class="mysto-cart-recently-viewed__media">
                    <img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}" loading="lazy">
                </span>
                <span class="mysto-cart-recently-viewed__name">${escapeHtml(product.title)}</span>
                ${priceMarkup}
            </a>
        </article>
    `;
}

function updateCartRecentlyViewedNav(sectionElement) {
    const track = sectionElement?.querySelector('[data-mysto-recent-track]');
    if (!track) return;

    const previousButton = sectionElement.querySelector('[data-mysto-carousel-nav="prev"]');
    const nextButton = sectionElement.querySelector('[data-mysto-carousel-nav="next"]');
    const maxScrollLeft = Math.max(0, track.scrollWidth - track.clientWidth - 2);

    if (previousButton) previousButton.disabled = track.scrollLeft <= 2;
    if (nextButton) nextButton.disabled = track.scrollLeft >= maxScrollLeft;
}

function renderCartRecentlyViewed(scope = document) {
    const cartDrawerRoot = getCartDrawerRoot(scope);
    const cartFooterSticky = cartDrawerRoot?.querySelector('cart-footer > .sticky');
    if (!cartFooterSticky) return;

    const viewedProducts = getRecentlyViewedProducts().slice(0, MYSTO_RECENTLY_VIEWED_LIMIT);
    const shippingBlock = cartFooterSticky.querySelector('cart-shipping');
    const shippingAnchor = shippingBlock?.closest('component-loader') || shippingBlock;
    if (!shippingAnchor) return;

    let sectionElement = cartFooterSticky.querySelector('.mysto-cart-recently-viewed');
    if (!viewedProducts.length) {
        if (sectionElement) sectionElement.remove();
        return;
    }

    if (!sectionElement) {
        sectionElement = document.createElement('section');
        sectionElement.className = 'mysto-cart-recently-viewed';
        shippingAnchor.insertAdjacentElement('afterend', sectionElement);
    }

    sectionElement.innerHTML = `
        <div class="mysto-cart-recently-viewed__head">
            <h3 class="mysto-cart-recently-viewed__title">Recently viewed</h3>
            <div class="mysto-cart-recently-viewed__nav" aria-label="Recently viewed products">
                <button type="button" class="mysto-cart-recently-viewed__nav-button" data-mysto-carousel-nav="prev" aria-label="Scroll recently viewed products left">Prev</button>
                <button type="button" class="mysto-cart-recently-viewed__nav-button" data-mysto-carousel-nav="next" aria-label="Scroll recently viewed products right">Next</button>
            </div>
        </div>
        <div class="mysto-cart-recently-viewed__viewport">
            <div class="mysto-cart-recently-viewed__track" data-mysto-recent-track>
                ${viewedProducts.map(getRecentlyViewedCardMarkup).join('')}
            </div>
        </div>
    `;

    const track = sectionElement.querySelector('[data-mysto-recent-track]');
    if (track && track.dataset.navBound !== 'true') {
        track.dataset.navBound = 'true';
        track.addEventListener('scroll', () => updateCartRecentlyViewedNav(sectionElement), {passive: true});
    }

    updateCartRecentlyViewedNav(sectionElement);
}

function updateCollectButton(button, formElement) {
    const productId = String(getCollectProductId(formElement));
    const isCollected = getCollectedProducts().includes(productId);
    const buttonLabel = isCollected ? 'Collected' : 'Collect';

    button.dataset.productId = productId;
    button.dataset.collected = isCollected ? 'true' : 'false';
    button.setAttribute('aria-pressed', isCollected ? 'true' : 'false');
    button.setAttribute('aria-label', buttonLabel);
    button.setAttribute('title', buttonLabel);

    const buttonCopy = button.querySelector('[data-mysto-collect-copy]');
    if (buttonCopy) buttonCopy.textContent = buttonLabel;
}

function createCollectButton(formElement) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'mysto-collect-button';
    button.innerHTML = `
        <span class="visually-hidden" data-mysto-collect-copy>Collect</span>
        <svg viewBox="0 0 24 24" focusable="false" aria-hidden="true">
            <path d="M6 3.75h12v16.5L12 15.75 6 20.25Z" />
        </svg>
    `;

    button.addEventListener('click', () => {
        const productId = String(button.dataset.productId || getCollectProductId(formElement));
        const collectedProducts = getCollectedProducts().filter(id => id !== productId);
        const shouldCollect = button.getAttribute('aria-pressed') !== 'true';

        if (shouldCollect) collectedProducts.unshift(productId);
        setCollectedProducts(collectedProducts);
        updateCollectButton(button, formElement);
    });

    return button;
}

function initProductCollectButtons(scope = document) {
    if (!isProductPage()) return;

    scope.querySelectorAll('ajax-cart-product-form form[data-type="add-to-cart-form"]').forEach(formElement => {
        const addButton = formElement.querySelector('button[name="add"], .add-2-cart');
        const actionStack = addButton?.closest('x-flex[direction="column"]') || addButton?.parentElement;
        if (!addButton || !actionStack) return;

        let actionRow = actionStack.querySelector('.mysto-product-actions');
        if (!actionRow) {
            actionRow = document.createElement('div');
            actionRow.className = 'mysto-product-actions';
            addButton.before(actionRow);
        }

        if (!actionRow.contains(addButton)) actionRow.append(addButton);

        let collectButton = actionRow.querySelector('.mysto-collect-button');
        if (!collectButton) {
            collectButton = createCollectButton(formElement);
            actionRow.append(collectButton);
        }

        updateCollectButton(collectButton, formElement);
    });
}

function getCartNoticeElement() {
    let cartNotice = document.getElementById('mystoCartNotice');
    if (cartNotice) return cartNotice;

    cartNotice = document.createElement('aside');
    cartNotice.id = 'mystoCartNotice';
    cartNotice.className = 'mysto-cart-notice';
    cartNotice.hidden = true;
    cartNotice.setAttribute('role', 'status');
    cartNotice.setAttribute('aria-live', 'polite');
    cartNotice.setAttribute('aria-atomic', 'true');
    cartNotice.innerHTML = `
        <span class="mysto-cart-notice__label">Added to cart</span>
        <a class="mysto-cart-notice__link" href="${window.routes?.cart_url || '/cart'}">${window.quickOrderListStrings?.viewCart || 'View cart'}</a>
    `;

    document.body.append(cartNotice);
    return cartNotice;
}

function hideMystoCartNotice() {
    const cartNotice = getCartNoticeElement();
    cartNotice.classList.remove('is-visible');

    clearTimeout(mystoCartNoticeHideTimeoutId);
    mystoCartNoticeHideTimeoutId = window.setTimeout(() => {
        if (!cartNotice.classList.contains('is-visible')) cartNotice.hidden = true;
    }, 220);
}

function showMystoCartNotice() {
    const cartNotice = getCartNoticeElement();
    const cartNoticeLink = cartNotice.querySelector('.mysto-cart-notice__link');

    if (cartNoticeLink) {
        cartNoticeLink.href = window.routes?.cart_url || '/cart';
        cartNoticeLink.textContent = window.quickOrderListStrings?.viewCart || 'View cart';
    }

    clearTimeout(mystoCartNoticeTimeoutId);
    clearTimeout(mystoCartNoticeHideTimeoutId);

    cartNotice.hidden = false;
    requestAnimationFrame(() => cartNotice.classList.add('is-visible'));

    mystoCartNoticeTimeoutId = window.setTimeout(() => {
        hideMystoCartNotice();
    }, MYSTO_CART_NOTICE_DURATION);
}

function getCurrentCartForm() {
    return document.querySelector('ajax-cart-product-form[processing]')
        || latestCartForm
        || document.activeElement?.closest('ajax-cart-product-form')
        || document.querySelector('ajax-cart-product-form');
}

function getCartDrawerRoot(scope = document) {
    if (scope?.querySelector) {
        const scopedDrawer = scope.querySelector('coretex-dialog#cartBox');
        if (scopedDrawer) return scopedDrawer;
    }

    return document.querySelector('coretex-dialog#cartBox');
}

function getCartDrawerItemCount(cartDrawerRoot) {
    const liquidCartCount = Number(window.liquidAjaxCart?.cart?.item_count);
    if (Number.isFinite(liquidCartCount)) return liquidCartCount;

    const cartElement = cartDrawerRoot?.querySelector('coretex-cart[data-ajax-cart-section]');
    const counter = Number(cartElement?.getAttribute('counter'));
    if (Number.isFinite(counter)) return counter;

    const headerCounter = Number(document.querySelector('cart-count[data-count]')?.getAttribute('data-count'));
    return Number.isFinite(headerCounter) ? headerCounter : 0;
}

function syncCartDrawerContent(scope = document) {
    const cartDrawerRoot = getCartDrawerRoot(scope);
    if (!cartDrawerRoot) return;

    const itemCount = getCartDrawerItemCount(cartDrawerRoot);
    const titleLabel = itemCount === 1 ? 'Item' : 'Items';
    const drawerTitle = cartDrawerRoot.querySelector('header .h6');
    if (drawerTitle) drawerTitle.textContent = `My Bag - ${itemCount} ${titleLabel}`;

    const subtotalLabel = cartDrawerRoot.querySelector('.subtotal > x-cell:first-child');
    if (subtotalLabel) subtotalLabel.textContent = 'Subtotal';

    const viewCartLink = cartDrawerRoot.querySelector('.viewCart');
    if (viewCartLink) viewCartLink.textContent = 'View bag';

    const emptyMessage = cartDrawerRoot.querySelector('section.empty x-cell:first-child span');
    if (emptyMessage) emptyMessage.textContent = 'Your bag is empty';

    renderCartRecentlyViewed(cartDrawerRoot);
}

document.addEventListener('liquid-ajax-cart:request-start', event => {
    const {requestState} = event.detail;
    if (requestState.requestType === 'add') {
        latestCartForm = getCurrentCartForm();
        document.body.setAttribute('cart-state', 'processing');
        pendingAddToCartAnalytics = buildAddToCartAnalyticsPayload(latestCartForm, requestState);
    }
});

// Replace the cart drawer popup with a fixed notice.
document.addEventListener('liquid-ajax-cart:request-end', event => {
    const {requestState} = event.detail;

    // # Update header cart counter
    const itemCount = window.liquidAjaxCart?.cart?.item_count || 0; // Get the item count
    document.querySelectorAll('[data-count]').forEach(function(el) {
        el.setAttribute('data-count', itemCount); // Update the data-count attribute
    });

    // # If the "add to cart" request is successful
    if (requestState.requestType === 'add' && requestState.responseData?.ok) {
        const formElement = getCurrentCartForm();
        const cartType = formElement?.getAttribute('cart-type');
        const addToCartPayload = pendingAddToCartAnalytics || buildAddToCartAnalyticsPayload(formElement, requestState);

        emitMystoAnalyticsEvent('add_to_cart', addToCartPayload);

        if (cartType === 'redirect') {
            const cartUrl = window.routes?.cart_url || '/cart';
            window.location.href = cartUrl;
        } else {
            showMystoCartNotice();
        }
    }

    // # Remove the "processing" attribute when the "add to cart" request has finished
    if (requestState.requestType === 'add') {
        document.body.removeAttribute('cart-state', 'processing');
        document.body.setAttribute('cart-state', 'done');
        pendingAddToCartAnalytics = null;
        setTimeout(function() { document.body.removeAttribute('cart-state', 'done') }, MYSTO_CART_NOTICE_DURATION);
    }

    // # Keep elements open when updating cart
    document.querySelectorAll('[data-ajax-cart-section] [data-ajax-cart-details]').forEach($details => {
        const key = $details.getAttribute('data-ajax-cart-details');
        if (!key) return;
        $details.open = cartDetailsOpen[key];
      });
      cartDetailsInit();
      syncCartDrawerContent();
});

// (Cart) Fix for details to stay open
const cartDetailsOpen = {};
function cartDetailsInit() {
  document.querySelectorAll('[data-ajax-cart-section] [data-ajax-cart-details]').forEach($details => {
    const key = $details.getAttribute('data-ajax-cart-details');
    if (!key) return;
    cartDetailsOpen[key] = $details.hasAttribute('open');
    $details.addEventListener('toggle', event => {
      cartDetailsOpen[key] = event.target.open;
    });
  });
}
cartDetailsInit();

//liquidAjaxCart.conf("updateOnWindowFocus", false);

// # Remove autofocus from inputs on Safari
window.addEventListener('user-agent', (event) => {
    if (event.detail.browser === 'safari') {
        document.querySelectorAll('[autofocus]').forEach(input => { input.removeAttribute('autofocus') });
        // console.log('Autofocus removed for Safari.');
    }
});

/***
 * 
 * 
 * Event Listeners
 * === [ CORETEX FYI ] ===
 * You may use 1 (one) eventlistener for all methods
 * 
 * 
*/

// Avoid repeating the same code by encapsulating the repeated logic into a function that you call from multiple places. 
// This way, if you need to update the logic later, you only have to do it in one place.
// this function will run on both "DOM ready" and "Resize".


// Keydown event handler for filter box
function filterBoxKeydown(event) {
    // Close filters box when ESC key is pressed
    if (event.key === 'Escape' && document.body.classList.contains('filtersBox-o')) document.body.classList.remove('filtersBox-o');
}

/**
 * Handles the Enter key press event for checkboxes and radio buttons.
 */
function handleEnterKey(event) {
    // Check if the Enter key is pressed
    if (event.key === 'Enter') {
        const activeElement = document.activeElement;
    
        // Ensure the focused element is either a checkbox or a radio button
        if (activeElement.tagName === 'INPUT' && ['checkbox', 'radio'].includes(activeElement.type)) {
            // Prevent default behavior
            event.preventDefault();
        
            // Trigger the click event to toggle/select the input
            activeElement.click();
        }
    }
}

// ===[ Global click listener ] ===
document.addEventListener('click', (event) => {
    const cartForm = event.target.closest('ajax-cart-product-form');
    if (cartForm) latestCartForm = cartForm;

    const carouselButton = event.target.closest('[data-mysto-carousel-nav]');
    if (carouselButton) {
        const sectionElement = carouselButton.closest('.mysto-cart-recently-viewed');
        const track = sectionElement?.querySelector('[data-mysto-recent-track]');
        if (!track) return;

        const direction = carouselButton.getAttribute('data-mysto-carousel-nav') === 'prev' ? -1 : 1;
        const scrollStep = Math.max(track.clientWidth * 0.86, 220);
        track.scrollBy({left: direction * scrollStep, behavior: 'smooth'});
    }

    trackHomepageSectionClick(event);
    // if (event) sampleMethod(event);
}, false);

document.addEventListener('submit', (event) => {
    const cartForm = event.target.closest('ajax-cart-product-form');
    if (cartForm) latestCartForm = cartForm;
}, true);

// ===[ Global keydown listener ] ===
document.addEventListener('keydown', (event) => {
    if (event) filterBoxKeydown(event);
    if (event) handleEnterKey(event);
}, false);


/*** 
// === [ CORETEX FYI ] ===
// Example usage

function sampleMethod(event) {
    const element = event.target.closest("[data-some-attr]"); // add your element class/id/data-attr.
    if (element) {
        event.preventDefault();
        //.... your logic here
    }
}
*/

// Code to be executed when the window is resized.
/***
 * === [ CORETEX FYI ] ===
 * We throttle/debounce the execution of functions to avoid performance issues.
*/
let debouncerId;
window.addEventListener('resize', () => {
    clearTimeout(debouncerId);
    debouncerId = setTimeout(() => {
        globalTasks(); // Run Global tasks
        // put other functions here
    }, 222); // Adjust delay as needed
});

// Code to be executed when DOM is ready.
document.addEventListener('DOMContentLoaded', function() {
    getNavigator(); // get user's device and browser
    globalTasks(); // Run Global tasks
    // put other functions Here
});

// Code to be executed when in the theme editor
if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
        getNavigator(); // get user's device and browser
        globalTasks(); // Run Global tasks
        // put other functions here
    });
}

/***
 * === [ CORETEX FYI ] ===
 * Fires on every component load and holds name of loaded component and other not loaded components
 * 🚨 Remove in production.
*/
// document.addEventListener('component-loaded', (evt) => console.log(evt.detail));
